import React, { useMemo } from 'react'
import { matchPath, useLocation } from 'react-router-dom'
import { RegionSelectorLink } from '@frontend/components/agromarket/components/RegionSelector'
import { useDeviceType } from '@pole/media-queries/agromarket'
import { EAgriculturalProductsRoute } from '@/types'
import { messages } from './messages'
import './styles.scss'

export const DeliveryRegionSelector = () => {
  const { pathname } = useLocation()
  const { isFromDevice } = useDeviceType()

  const shouldShowSelector = useMemo(() => {
    const whitelist: string[] = [EAgriculturalProductsRoute.main, EAgriculturalProductsRoute.category, EAgriculturalProductsRoute.product]

    return !!(pathname && matchPath(pathname, whitelist))
  }, [pathname])

  if (!shouldShowSelector || isFromDevice('desktop')) return null

  return (
    <div className={'deliveryRegionSelector__container page-wrapper'}>
      <span>{messages.label}</span>
      <RegionSelectorLink />
    </div>
  )
}
